import { GetClientType } from "../config";
export default function getProfileType  (product){
    
    if (product?.buttons != null ) {
        var buttons = product?.buttons;

        if (buttons.includes('object')  ) {
            return "object";
        } else if (buttons.includes('texture')) {
            return "texture"
        } else if (buttons.includes('add_to_project')) {
            if(GetClientType() == "revit"){
               return "material";

            }else{
              return "2d";

            }
        }else if(buttons.includes('add_to_object')){
            return "object";
        } else if (buttons.includes('add_to_line')) {
           return "sweep_maker";
        }
        else {
          return  "all";
        }
    } else {
        return "all";
    }
}